<script setup>
import {ref} from "vue";
import Modal from "@/components/modal/Modal.vue";
import CallersCard from "./CallersCard.vue";
import PatientsCard from "./PatientsCard.vue";

const props = defineProps({
  hpo: {
    type: Object,
    required: true,
  },
  member: {
    type: Object,
    required: true,
  },
  countries: {
    type: Array,
    required: true,
  },
});

// P1 (Codex): emit('close') requires emit to be declared.
const emit = defineEmits(['close']);

function close() {
  emit('close');
}

const tab = ref('caller');
const selectedCaller = ref(null);

// A caller chosen in the Caller tab (match or create): record it and advance
// to the (stubbed) Patients tab.
function handleSelectCaller(caller) {
  selectedCaller.value = caller;
  tab.value = 'patients';
}
</script>

<template>
  <Modal :title="pgettext('title', 'New Call')" @close="close" :max-width="1200">
    <PatientsCard v-if="selectedCaller"
                 :hpo="hpo"
                 :caller="selectedCaller"
                 :member="member"
                 :countries="countries"
    />
    <CallersCard v-else
                 :hpo="hpo"
                 @selectCaller="handleSelectCaller"
    />
  </Modal>
</template>

<style>
</style>
